/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".version[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:'#666666'}.version[_ngcontent-%COMP%]:hover   span[_ngcontent-%COMP%]{cursor:default}"];
export { styles as styles };
